import { render, staticRenderFns } from "./_ListPassageInfirmerie.vue?vue&type=template&id=34b80542&"
import script from "./_ListPassageInfirmerie.vue?vue&type=script&lang=ts&"
export * from "./_ListPassageInfirmerie.vue?vue&type=script&lang=ts&"
import style0 from "./_ListPassageInfirmerie.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports